(function() {
    var options = {
            method: "get",
            noCache: true,
            ignoreError: false
        },

        sessionNames = {},
        requestQueue = [],
        loginDialog = null,


        klass = {
            Extends: Request,

            options: options,

            onFailureFn: null,
            onResubmitFn: null,
            onAuthFailureFn: null,

            initialize: function(options) {
                this.onFailureFn = options.onFailure;
                this.onResubmitFn = options.onException;
                this.onAuthFailureFn = options.onAuthFailure;

                options.onFailure = null;
                options.onException = null;

                this.setOptions(options);
                this.parent(this.options);
            },

            send: function(options) {
                if (typeof this.options.data == "string")
                    this.options.urlEncoded = false;

                this.parent(options);
            },

            onFailure: function() {
                if (this.status != 401 && this.options.ignoreError)
                    return;

                this.parent();

                if (this.status == 401) {
                    if (typeof this.onAuthFailureFn == "function")
                        this.onAuthFailureFn();

                    this.promptLogin();
                }
                else {
                    var error = this.getErrorMessage();

                    if (typeof this.onFailureFn == "function")
                        this.onFailureFn(error, this.xhr);
                }
            },

            getErrorMessage: function() {
                var xhr = this.xhr;

                if (xhr && xhr.status >= 400)
                    return xhr.responseText;

                return "";
            },

            promptLogin: function() {
                // Add failed requests to queue for retrying
                requestQueue.push(this);
                // Reset the list of session names
                sessionNames = {};

                // If we get a 401, the session expired and we should pop the login dialog.
                // If it logs on successfully, resend the requests.
                if (!loginDialog || loginDialog.isClosing) {
                    loginDialog = new Librarian.LoginDialog({
                        onSuccess: this.onRelogin.bind(this)
                    }).show();
                }
            },

            onRelogin: function() {
                while (requestQueue.length) {
                    var request = requestQueue.shift();

                    if (typeof request.onResubmitFn == "function")
                        request.onResubmitFn();
                    else
                        request.send();
                }

                Librarian.Utils.reloadThumbnails();

                // Refresh the preview thumbnails as well
                if ((typeof previewWindows != "undefined") && (previewWindows != null)) {
                    for (var i = 0; i < previewWindows.length; i++) {
                        if (previewWindows[i])
                            previewWindows[i].reloadThumbnail();
                    }
                }

                loginDialog = null;
            }
        };

    Librarian.Request = new Class(klass);

    klass.Extends = Request.JSON;

    Librarian.Request.JSON = new Class(klass);

    klass.Extends = Request.HTML;

    Librarian.Request.HTML = new Class(klass);

})();